module.exports = __webpack_public_path__ + "img/gift-fill.e0789876.svg";